import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import "../studentPortal/Dashboard.css";
import authService from '../../services/auth.service';

const DashbardHeader = ({studentDetails}) => {

const navigate = useNavigate();
    
  const logout = () => {
    authService.logoutUser();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
     navigate("/student/login", { replace: true });
    }, 2000);
    
  };

    const [loading, setLoading] = useState(false);

  return (
   <>
      <div className="dashboard-page" id="Dashbard-Page">
        <div className="dashboard-header">
          <Link to={"/student/dashboard"}>
          <img
            src="https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png"
            alt="College Logo"
          />
          <h2>Student Portal</h2>
          </Link>
          
        </div>
        <div className="dashboard-navbar-last-box">
          <button onClick={() => logout()} className="logout-button">
            Logout
          </button>
          <div className='header-user-image'>
            <img src={studentDetails.profile_photo }/>
          </div>
        </div>
      </div>
   </>
  )
}

export default DashbardHeader